<div class="activity-list">
    <div *ngIf="!agreementId" class="switch-toggle">
        <input
            type="checkbox"
            id="viewSwitch"
            [checked]="selected === viewType.Mine"
            (change)="changeView(selected === viewType.All ? viewType.Mine : viewType.All)"
        />
        <label class="switch-label" for="viewSwitch">
            <span class="switch-inner">
                <span class="switch-option" [class.active]="selected === viewType.All">
                    {{ 'FEATURES.ACTIVITY.ALL_ACTIVITIES' | translate }}
                </span>
                <span class="switch-option" [class.active]="selected === viewType.Mine">
                    {{ 'FEATURES.ACTIVITY.MY_ACTIVITIES' | translate }}
                </span>
            </span>
            <span class="switch-slider"></span>
        </label>
    </div>

    <div *ngFor="let activity of activities$ | async" class="activity-item">
        <div>
            <a
                *ngIf="activity.objectTypeId === 0; else plainText"
                [routerLink]="['/agreement/details', activity.objectId]"
            >
                {{ getActivityText(activity) }}
            </a>
            <ng-template #plainText>{{ getActivityText(activity) }}</ng-template>
        </div>
        <div class="time">
            {{ activity.created | dateTime: 'yyyy-MM-dd' }}
        </div>
    </div>
</div>
